import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { formatDateTimeUtils } from "../../utils/comman";

const TransactionDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const transaction = useSelector((state) =>
    state.wallet.transactions.find((tx) => tx.transactionId === id),
  );
  const paymentDetails = transaction?.paymentDetails;
  const paymentScreenshot = transaction?.images;
  const status = transaction?.txStatus;

  const isRejected = String(status || "").toUpperCase() === "REJECTED";
  const isSuccess = ["SUCCESS", "ACCEPTED"].includes(
    String(status || "").toUpperCase(),
  );
  const isPending = String(status || "").toUpperCase() === "PENDING";

  const accentColor = isRejected
    ? "#ef4444"
    : isSuccess
      ? "#22c55e"
      : isPending
        ? "#eab308"
        : "#3b82f6";

  return (
    <div className="section accounts ">
      <h2 className="userscreen-title mb-4">Transaction Details</h2>

      <div
        className="card shadow-sm rounded-3"
        style={{
          borderLeft: `5px solid ${accentColor}`,
          background: "#f9fafb",
        }}
      >
        {!transaction ? (
          <div className="p-4 text-center text-muted">
            Transaction not found.
          </div>
        ) : (
          <div className="p-4">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
              <div>
                <div
                  className="fw-bold"
                  style={{
                    color: accentColor,
                    fontSize: 14,
                    letterSpacing: 1,
                  }}
                >
                  {transaction?.txStatus}
                </div>

                <div className="text-muted small">
                  {formatDateTimeUtils(transaction?.startTime)}
                </div>
              </div>

              <div className="fw-bold fs-4">₹ {transaction?.amount || "-"}</div>
            </div>

            {/* Divider */}
            <hr />

            {/* Info */}
            <div className="row gy-3 mt-1">
              {[
                ["Transaction ID", transaction?.transactionId],
                ["Transaction Type", transaction?.transactionType],
                ["Payment Method", transaction?.paymentMethod],
                ["UPI ID", paymentDetails?.upi_id || paymentDetails?.others],
                ["Account Holder", paymentDetails?.bank_holder_name],
                ["Username", paymentDetails?.user_name],
                ["Method", paymentDetails?.method_name],
              ].map(([label, value], i) => (
                <div className="col-md-6" key={i}>
                  <div>
                    <div className="text-muted small">{label}</div>
                    <div className="fw-semibold text-dark">{value || "-"}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      {/* Notes Section */}
      <div className="mt-4 px-2">
        <div className="fw-semibold mb-2">Remarks</div>

        {transaction?.notes ? (
          <div
            className="p-3 rounded-3"
            style={{
              background: "#f9fafb",
              border: "1px solid #eee",
            }}
          >
            {transaction.notes}
          </div>
        ) : (
          <div
            className="text-muted text-center p-4 rounded-3"
            style={{
              border: "1px dashed #ccc",
              background: "#fafafa",
            }}
          >
            No remarks
          </div>
        )}
      </div>

      {/* Screenshot Section */}
      <div className="mt-4 px-2">
        <div className="fw-semibold mb-2">Payment Screenshot</div>

        {paymentScreenshot ? (
          <a href={paymentScreenshot} target="_blank" rel="noreferrer">
            <img
              src={paymentScreenshot}
              alt="Payment screenshot"
              className="img-fluid rounded-3 shadow-sm"
              style={{
                maxHeight: 800,
                objectFit: "cover",
                border: "1px solid #eee",
              }}
            />
          </a>
        ) : (
          <div
            className="text-muted text-center p-4 rounded-3"
            style={{
              border: "1px dashed #ccc",
              background: "#fafafa",
            }}
          >
            No screenshot attached
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionDetails;
